import { ThemeColor } from '../theme.types'

export const DEFAULT_THEME = {
  [ThemeColor.Base]: '',
  [ThemeColor.Essential]: '',
  [ThemeColor.Brand]: '',
  [ThemeColor.System]: '',
  [ThemeColor.Error]: '',
  [ThemeColor.Warning]: '',
  [ThemeColor.Success]: '',
  [ThemeColor.Info]: '',
}
